import type { Role } from '@customTypes/types';
import { create } from 'zustand';
import { createJSONStorage, persist, devtools } from 'zustand/middleware';

export type Profile = {
  profileIds: number[];
  role: Role;
};

interface ProfileStore {
  profile: Profile | null;
  profileDataIsLoading: boolean;
  currentSessionId: number | null;
  isAuthenticated: boolean;
  countryName: string | null;
  updateProfile: (profile: Profile | null) => void;
  updateCurrentSessionId: (currentSessionId: number | null) => void;
  updateprofileDataIsLoading: (profileDataIsLoading: boolean) => void;
  setCountryName: (code: string) => void;
  userEmail: string | null;
  setUserEmail: (email: string) => void;
  isSubscribed: boolean;
  subscriptionChecked: boolean;
  setIsSubscribed: (isSubscribed: boolean) => void;
  setSubscriptionChecked: (subscriptionChecked: boolean) => void;
  canRate: boolean;
  setCanRate: (value: boolean) => void;
}

export const useProfileStore = create<ProfileStore>()(
  devtools(
    persist(
      (set) => ({
        profile: null,
        profileDataIsLoading: true,
        isAuthenticated: false,
        currentSessionId: null,
        countryName: null,
        userEmail: null,
        isSubscribed: false,
        subscriptionChecked: false,
        canRate: false,

        updateProfile: (profile) =>
          set({
            profile,
            isAuthenticated: !!profile,
            profileDataIsLoading: false
          }),
        updateCurrentSessionId: (currentSessionId) => set({ currentSessionId }),
        updateprofileDataIsLoading: (profileDataIsLoading) =>
          set({ profileDataIsLoading }),

        setCountryName: (code: string) => set({ countryName: code }),
        setUserEmail: (email: string) => set({ userEmail: email }),
        setIsSubscribed: (isSubscribed) => set({ isSubscribed }),
        setSubscriptionChecked: (subscriptionChecked) =>
          set({ subscriptionChecked }),
        setCanRate: (value: boolean) => set({ canRate: value })
      }),
      {
        name: 'profile',
        storage: createJSONStorage(() => localStorage)
      }
    )
  )
);
